import React from "react";
import LegalPage from "@/pages/LegalPage";

export default function Affiliates() {
    return (
        <LegalPage title="Become an Affiliate">
            <div className="rounded-2xl bg-gold/15 border border-gold/40 p-6 not-prose">
                <p className="font-bold text-burnt text-lg mb-2">
                    Our affiliate program is launching soon
                </p>
                <p className="text-navy/80">
                    Love Caribbean Meal Prep? Soon you&rsquo;ll be able to share
                    your love and get paid for it. Sign up to the early-access
                    list by emailing{" "}
                    <a
                        href="mailto:caribbeanmealp@gmail.com?subject=Affiliate%20Program%20—%20Early%20Access"
                        className="text-forest font-bold underline"
                    >
                        caribbeanmealp@gmail.com
                    </a>{" "}
                    with the subject &ldquo;Affiliate Program — Early
                    Access&rdquo; and we&rsquo;ll be in touch when the program
                    opens.
                </p>
            </div>
        </LegalPage>
    );
}
